import { render, staticRenderFns } from "./RatingCauses.vue?vue&type=template&id=75b9d84c&scoped=true"
import script from "./RatingCauses.vue?vue&type=script&lang=js"
export * from "./RatingCauses.vue?vue&type=script&lang=js"
import style0 from "./RatingCauses.vue?vue&type=style&index=0&id=75b9d84c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b9d84c",
  null
  
)

export default component.exports